import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FooterWidget } from '@/pages/landing/components/footerwidget';
import { TopbarWidget } from '@/pages/landing/components/topbarwidget';
import { LayoutService } from '../service/layout.service';
import { AppConfigurator } from './app.configurator';

@Component({
    selector: 'app-landing-layout',
    standalone: true,
    imports: [
        CommonModule,
        TopbarWidget,
        RouterModule,
        FooterWidget,
        AppConfigurator
    ],
    // <app-topbar-widget />
    template: `
        <main>
            <router-outlet></router-outlet>
        </main>
        <!-- <button
            class="layout-config-button config-link"
            (click)="layoutService.toggleConfigSidebar()"
        >
            <i class="pi pi-cog"></i>
        </button> -->
    `
})
export class LandingLayout {
    layoutService: LayoutService = inject(LayoutService);
}
